import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=2ecbc36a&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ecbc36a')) {
      api.createRecord('2ecbc36a', component.options)
    } else {
      api.reload('2ecbc36a', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=2ecbc36a&", function () {
      api.rerender('2ecbc36a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27uD4Uvw1XjPY/JS/ImageCarousel.vue"
export default component.exports